import { register } from '../component.js';
import 'react';

var _socialIcons_vevo = register("vevo", {"color":"#ED1A3B","path":"M0 0v64h64V0zm34.2 41.9c-1.4 2.1-2.9 3.1-5 3.1 0 0-3 .2-4.1-3.4L20 21h8.1l3 12.3c1.4-2.1 5.1-7.7 5.1-7.7 1.4-1.9 2.2-4.6 6.8-4.6h5z"});

export { _socialIcons_vevo as default };
